var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4"},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbItems}}),_c('lead-property-tracker')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }